<div class="container">

  <app-header-dialog [iconName]="'attach_money'">
    Anuidade Lote - Regras
  </app-header-dialog>

  <div class='price-form'>

    <div class='left-form'>

      <mat-form-field class="name-width" appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
          Informe um nome
        </mat-error>
      </mat-form-field>

      <mat-form-field class="name-width" appearance="outline">
        <mat-label>Valor</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.value"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.value.hasError('required')">
          Informe um valor
        </mat-error>
      </mat-form-field>

      <mat-form-field class="name-width" appearance="outline">
        <mat-label>Valor PIX</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.value_pix"
          autocomplete="off">
        <mat-error *ngIf="entityForm.controls.value_pix.hasError('required')">
          Informe um valor
        </mat-error>
      </mat-form-field>

    </div>

    <div class='right-form'>

      <form name="priceForm" [formGroup]='priceForm' autocomplete="off">

        <mat-form-field class="category-width" appearance="outline">
          <mat-label>Categoria</mat-label>
          <mat-select (ngModelChange)='selectCategory($event)' [errorStateMatcher]="matcher"
            [formControl]="priceForm.controls.category_id">
            <mat-option *ngFor="let subcat of arraySubCategories" [value]="subcat.id">
              {{ subcat.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="priceForm.controls.category_id.hasError('required')">
            Selecione uma categoria
          </mat-error>
        </mat-form-field>

        <button mat-raised-button (click)='addSubCategory()'>
          <mat-icon class='icon-add'>add_circle_outline</mat-icon>
        </button>

      </form>


      <!-- TABLE -->
      <mat-table [dataSource]="selectedSubCategoriesDataSource" matSort style='height:300px; overflow:auto; margin: 0;'>

        <!-- icon Column -->
        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>attach_money</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef> Categoria </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }} </mat-cell>
        </ng-container>


        <!-- delete Column -->
        <ng-container matColumnDef="delete">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a mat-button (click)='removeSubCategory(element)' style='background-color: whitesmoke;'>
              <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
              </mat-icon>
            </a>
          </mat-cell>
        </ng-container>

        <!-- Header -->
        <mat-header-row *matHeaderRowDef="displayedCategoryPricesColumns"></mat-header-row>

        <!-- Row -->
        <mat-row *matRowDef="let row; columns: displayedCategoryPricesColumns;">
        </mat-row>

      </mat-table>
      <!-- END TABLE -->

    </div>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)='update()' *ngIf='isEdit'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='insert()' *ngIf='!isEdit'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>